<template>
<div class="chapter">
<div class="inner_page">
<p class="end-title1-a"><b><span>PRAISE FOR THE WRITING OF ANDREW KAPLAN</span></b></p>
<p class="section-1a"><span><i>War of the Raven</i></span></p>
<p class="normal-1">“In a word, <i>terrific</i> … The pace is blistering, the atmosphere menacing and decadent, and author Andrew Kaplan is in marvelously smashing form.” —<i>Daily News</i> (New York)</p>
<p class="normal-1">“The characters and locales are brilliantly etched … the plot riveting.” —<i>The Times</i> (London)</p>
<p class="normal-1">“A smashing, sexy and unforgettable read.” —<i>Publishers Weekly</i></p>
<p class="section-1a"><span>Scorpion</span></p>
<p class="normal-1">“Pure dynamite … espionage laced with high-voltage Middle East adventure.” —<i>The Washington Times</i></p>
<p class="normal-1">“A fast-paced, supercharged debut thriller.” —<i>Kirkus Reviews</i></p>
<p class="section-1a"><span>Dragonfire</span></p>
<p class="normal-1">“A superb and original blending of Eastern mysticism with the shadowy world of espionage.” —Nelson DeMille, <i>New York Times</i>-bestselling author of <i>Word of Honor</i></p>
<p class="normal-1">“Electrifying … A searing, ultimately satisfying entertainment with energy, passion, and moral resonance.” —<i>Kirkus Reviews</i></p>
<p class="section-1a"><span>Hour of the Assassins</span></p>
<p class="normal-1">“An exciting, original suspense novel.” —<i>Buffalo Evening News</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// endmatter03.vue?ae1851e0